import { Component, input, InputSignal, OnChanges, output, signal, SimpleChanges } from '@angular/core';

import { TableHeaderComponent } from '../../widget-components/table/table-header.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { TranslatePipe } from '@next/core-lib/i18n';
import { toLocaleSignal } from 'src/app/shared/utils';

@Component({
    selector: 'app-disease-overview-table-header',
    styleUrl: '../table.component.scss',
    template: `
    <div class="flex--row">
      <div class="header-cell flex__child--4 text--left">
        <mat-checkbox [checked]="_allSelected()" (click)="onSelectAllEvent()">
        </mat-checkbox>
      </div>
      @for (date of selectedDates(); track date) {
        <div class="header-cell flex__child--3 text--center" [class.today]="isToday(date)">
          @if (isToday(date)) {
            <span class="text--bold">{{ 'shared.diseaseTable.today' | translate }}</span>
          }
          <span>{{ date | date: 'EE dd/MM' : undefined : localeChanged() | titlecase }}</span>
        </div>
      }
    </div>
  `,
    imports: [
        MatCheckbox,
        TitleCasePipe,
        DatePipe,
        TranslatePipe,
    ],
})
export class OverviewTableHeaderComponent extends TableHeaderComponent implements OnChanges {
  protected readonly _allSelected = signal<boolean>(false);

  public readonly allSelected: InputSignal<boolean> = input.required<boolean>();
  public readonly selectAllClicked = output<boolean>();

  protected readonly localeChanged = toLocaleSignal(this.localeService);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.allSelected) {
      this._allSelected.set(changes.allSelected.currentValue);
    }
  }

  protected onSelectAllEvent(): void {
    this.selectAllClicked.emit(!this._allSelected());
  }
}
